import React, { useState, useEffect } from 'react';
import {
  AppBar, Toolbar, Typography, Container, CssBaseline, ThemeProvider,
  Box, TextField, Button, MenuItem, Divider, Paper
} from '@mui/material';
import { createTheme } from '@mui/material/styles';
import Footer from '../pages/Footer';
import logo from '../logo.png';
import axios from 'axios';

const defaultTheme = createTheme({
  palette: {
    primary: { main: 'rgb(18,82,166)' },
    background: { default: '#f5f5f5' },
  },
  typography: {
    fontFamily: '"Times New Roman", Times, serif',
  },
});

export default function ForgotUsernamePage() {
  const [firstName, setFirstName] = useState('');
  const [fathersName, setFathersName] = useState('');
  const [university, setUniversity] = useState('');
  const [department, setDepartment] = useState('');
  const [universities, setUniversities] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [username, setUsername] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get('https://exam.ethernet.edu.et/api/universities')
      .then(res => setUniversities(res.data));
    axios.get('https://exam.ethernet.edu.et/api/departments')
      .then(res => setDepartments(res.data));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setUsername(null);
    setError('');

    try {
      const res = await axios.post('https://exam.ethernet.edu.et/api/forgot-username', {
        firstName,
        fathersName,
        university,
        department,
      });

      if (res.data?.username) {
        setUsername(res.data.username);
      } else {
        setError('Profile not found. Please check your information.');
      }
    } catch {
      setError('Something went wrong. Please try again.');
    }
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <CssBaseline />
      <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <AppBar position="static">
          <Toolbar>
            <img src={logo} alt="Ministry of Education Logo" style={{ maxHeight: '70px', marginRight: '20px' }} />
            <Typography variant="h6" sx={{ flexGrow: 1 }}>
              Ministry of Education
            </Typography>
          </Toolbar>
        </AppBar>

        <Container component="main" sx={{ flex: 1, my: 6 }}>
  <Box sx={{ maxWidth: 500, mx: 'auto' }}>
    <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>

            <Typography variant="h5" align="center" gutterBottom>
              Forgot Username
            </Typography>
            <Typography variant="body1" align="center" sx={{ mb: 3 }}>
              Please provide your academic details to retrieve your username.
            </Typography>

            <Divider sx={{ mb: 3 }} />

            <form onSubmit={handleSubmit}>
              <TextField fullWidth label="First Name" required value={firstName}
                onChange={(e) => setFirstName(e.target.value)} sx={{ mb: 2 }} size="small" />
              <TextField fullWidth label="Father's Name" required value={fathersName}
                onChange={(e) => setFathersName(e.target.value)} sx={{ mb: 2 }} size="small" />

              <TextField
                select fullWidth required label="University" value={university}
                onChange={(e) => setUniversity(e.target.value)} sx={{ mb: 2 }} size="small"
              >
                {universities.map((u) => (
                  <MenuItem key={u.id} value={u.id}>{u.name}</MenuItem>
                ))}
              </TextField>

              <TextField
                select fullWidth required label="Department" value={department}
                onChange={(e) => setDepartment(e.target.value)} sx={{ mb: 2 }} size="small"
              >
                {departments.map((d) => (
                  <MenuItem key={d.id} value={d.id}>{d.name}</MenuItem>
                ))}
              </TextField>

              {username && (
                <Typography sx={{ mt: 2, color: 'green' }}>
                  ✅ Your username is: <strong>{username}</strong>
                </Typography>
              )}

              {error && (
                <Typography sx={{ mt: 2, color: 'error.main' }}>
                  {error}
                </Typography>
              )}

              <Box sx={{ textAlign: 'right', mt: 3 }}>
                <Button type="submit" variant="contained">Get Username</Button>
              </Box>
            </form>
            </Paper>
  </Box>
</Container>

        <Footer />
      </Box>
    </ThemeProvider>
  );
}
